module.exports = __webpack_public_path__ + "img/CovidSector_Desktop_Banner.49132b24.jpg";